import { create } from 'zustand';
import { api, tokenStore } from '../lib/api';
import { initLiff, liffLogout } from '../lib/liff';

export type OfficerStatus = 'pending' | 'active' | 'suspended';
export type OfficerRole = 'officer' | 'supervisor' | 'admin';

export interface OfficerProfile {
  id: string;
  lineUserId: string;
  lineDisplayName: string | null;
  linePictureUrl: string | null;
  firstName: string;
  lastName: string;
  opdCardNo: string | null;
  unitId: string | null;
  phone: string | null;
  role: OfficerRole;
  status: OfficerStatus;
  approvedAt: string | null;
  createdAt: string;
}

interface AuthState {
  ready: boolean;
  loading: boolean;
  error: string | null;
  officer: OfficerProfile | null;
  bootstrap: () => Promise<void>;
  refreshMe: () => Promise<void>;
  setOfficer: (o: OfficerProfile) => void;
  logout: () => void;
}

export const useAuth = create<AuthState>((set, get) => ({
  ready: false,
  loading: false,
  error: null,
  officer: null,

  bootstrap: async () => {
    set({ loading: true, error: null });
    try {
      const profile = await initLiff();
      const { data } = await api.post('/app/auth/line-login', { idToken: profile.idToken });
      tokenStore.set(data.token);
      set({ officer: data.officer, ready: true, loading: false });
    } catch (err) {
      const message = err instanceof Error ? err.message : 'เข้าสู่ระบบไม่สำเร็จ';
      set({ error: message, ready: true, loading: false });
    }
  },

  refreshMe: async () => {
    const { data } = await api.get('/app/me');
    set({ officer: data });
  },

  setOfficer: (o) => set({ officer: o }),

  logout: () => {
    tokenStore.clear();
    set({ officer: null });
    liffLogout();
    location.reload();
  },
}));
